import { gql } from '@apollo/client';

export default gql`
  mutation uploadInspectionFile($inspectionId: ID!, $file: Upload!) {
    uploadInspectionFile(input: { inspectionId: $inspectionId, file: $file }) {
      externalFile {
        id
        filename
        contentType
        fileSize
        externalUrl
        isImage
        isPdf
        fileExtension
      }
    }
  }
`;
